import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { createReview } from '../api/reviewsApi';
import StarRating from '../components/StarRating';

export default function CreateReview(){
  const nav = useNavigate();
  const [form, setForm] = useState({
    title:'', platform:'PC', genre:'Action', author:'', rating:4.0, summary:'', body:''
  });
  const [loading, setLoading] = useState(false);
  const [imageLoading, setImageLoading] = useState(false);

  function update(k, v){ setForm(prev=> ({...prev, [k]: v})) }

  // 🔍 Fetch image when title changes
  useEffect(() => {
    const proxyBase = "https://www.sfrogley.com/react-projects/gamerfrog/steamgrid-proxy.php?url=";

    const fetchImage = async () => {
      if (!form.title.trim()) return;
      setImageLoading(true);
      try {
        // 1️⃣ Search game by title
        const searchUrl = `https://www.steamgriddb.com/api/v2/search/autocomplete/${encodeURIComponent(form.title)}`;
        const searchRes = await fetch(`${proxyBase}${encodeURIComponent(searchUrl)}`);
        const searchData = await searchRes.json();

        if (!searchData?.data?.length) {
          setForm(prev => ({ ...prev, imageUrl: '' }));
          setImageLoading(false);
          return;
        }

        const gameId = searchData.data[0].id;

        // 2️⃣ Fetch grids with the same proxy
        const gridUrl = `https://www.steamgriddb.com/api/v2/grids/game/${gameId}?dimensions=920x430&nsfw=false`;
        const gridRes = await fetch(`${proxyBase}${encodeURIComponent(gridUrl)}`);
        const gridData = await gridRes.json();

        if (gridData?.data?.length) {
          setForm(prev => ({ ...prev, imageUrl: gridData.data[0].url }));
        } else {
          setForm(prev => ({ ...prev, imageUrl: '' }));
        }

      } catch (err) {
        console.error('Image fetch error:', err);
      } finally {
        setImageLoading(false);
      }
    };

    const debounce = setTimeout(fetchImage, 1000); // wait 1s after typing
    return () => clearTimeout(debounce);
  }, [form.title]);

  async function handleSubmit(e){
    e.preventDefault();
    setLoading(true);
    try {
      const created = await createReview(form);
      nav(`/react-projects/gamerfrog/reviews/${created.id}`);
    } catch(err){
      alert('Failed to save: ' + err.message);
    } finally { setLoading(false) }
  }

   return (
    <div className="createCard">
      <style>{` .starRatingValue { display: none; }`}</style>
      <h2>Write a review</h2>
      <form onSubmit={handleSubmit} style={{ marginTop: 8 }}>
          {imageLoading && <p style={{ color: 'gray' }}>Fetching image...</p>}
          {form.imageUrl && (
            <div className='imgPreview'>
              <img
                src={form.imageUrl}
                alt={form.title}
              />
            </div>
          )}
        <div className="form-row">
          <input
            className="input"
            required
            placeholder="Title"
            value={form.title}
            onChange={e => update('title', e.target.value)}
          />
          <input
            className="input"
            required
            placeholder="Developer"
            value={form.developer}
            onChange={e => update('developer', e.target.value)}
          />
          <input
            className="input"
            required
            placeholder="Publisher"
            value={form.publisher}
            onChange={e => update('publisher', e.target.value)}
          />
        </div>
        <div className="form-row">
          <select
            className="input"
            value={form.platform}
            onChange={e => update('platform', e.target.value)}
          >
            <option>PC</option>
            <option>PlayStation</option>
            <option>Xbox</option>
            <option>Nintendo</option>
            <option>Sega</option>
          </select>
          <input
            className="input"
            placeholder="Genre"
            value={form.genre}
            onChange={e => update('genre', e.target.value)}
          />
        </div>
        <h3 className="qBlock">Star Rating</h3>
        <div className="form-row">
          <StarRating value={form.rating} onChange={(v) => update('rating', v)} />
          <input
            className="input"
            type="number"
            step="0.1"
            min="0"
            max="5"
            value={form.rating}
            onChange={(e) => update('rating', parseFloat(e.target.value) || 0)}
            style={{ width: 80, marginTop: 6 }}
          />
        </div>
        <div className="form-row">
          <input
            className="input"
            placeholder="Short summary"
            value={form.summary}
            onChange={e => update('summary', e.target.value)}
          />
        </div>

        <div style={{ marginTop: 8 }}>
          <textarea
            className="input"
            rows={6}
            placeholder="Full review body"
            value={form.body}
            onChange={e => update('body', e.target.value)}
            style={{ width: '100%' }}
          />
        </div>

        <div style={{ marginTop: 12, display: 'flex', gap: 8 }}>
          <button className="btn" type="submit" disabled={loading}>
            {loading ? 'Saving...' : 'Publish'}
          </button>
          <button type="button" className="btn ghost" onClick={() => nav(-1)}>
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
}